var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center","cols":"12"}},[_c('CartOld',{attrs:{"order":_vm.order}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }